<template>
  <v-form ref="pushNotificationForm" v-model="valid" class="notification-page">
    <v-row>
      <v-col cols="12">
        <h1>Уведомления</h1>
      </v-col>

      <v-col cols="12" sm="5" md="4" xl="3">
        <v-img :src="previewImage(true, headerImage)" width="246" height="195" class="mb-8">
          <template v-slot:placeholder>
            <div class="image-placeholder">
              <img class="noimage-preview" src="@/assets/noImage.jpg"/>
            </div>
          </template>
        </v-img>
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="1768х1402"
                      append-icon="mdi-attachment"
                      v-model="headerImage">
        </v-file-input>


        <div>
          <label class="typo__label">По приложению</label>
          <multiselect
              :options="appTypes"
              v-model="notification.app_type"
              @input="appChange()"
              track-by="id"
              :rules="[rules.required]"
              outlined
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder=""
              label="text"
              :preselect-first="false"
              :taggable="false"
          >
          </multiselect>
        </div>


        <div class="mb-4">
          <label class="typo__label">По версии АПИ</label>
          <multiselect
              @input="appVersionChange()"
              :options="appVersionsFiltered"
              v-model="notification.version"
              track-by="id"
              :rules="[rules.required]"
              outlined
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder=""
              label="text"
              :preselect-first="false"
              :taggable="false"
          >
          </multiselect>
        </div>




        <div class="mb-4">
          <label class="typo__label">По Номеру телефона</label>
          <multiselect
              @search-change="phoneInputChange"
              @input="appPhoneChange()"
              :options="userPhones"
              :loading="loading"
              v-model="notification.number"
              track-by="id"
              :rules="[rules.required]"
              outlined
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder=""
              label="text"
              :preselect-first="false"
              :taggable="false"
          >
          </multiselect>
        </div>

        <div class="mb-4">

          <label class="typo__label">Список контактов</label>

          <v-file-input label="Файл xlsx"
                        prepend-icon=""
                        class="cursor-pointer"
                        outlined
                        placeholder="В первом столбце по одному в строке"
                        append-icon="mdi-attachment"
                        @change="onContactFilterChange"
                        v-model="listOfContact">
          </v-file-input>
        </div>

        <date-range-picker
            ref="picker"
            :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
            v-model="notification.date_range"
            opens="inline"
            :autoApply="true"
            :showDropdowns="true"
            @select="onDateChange()"
        >
          <template v-slot:input="picker" style="min-width: 350px;">
            <span class="date-range-label">Дата последнего закааза:</span>
            {{ picker.startDate | date }} - {{ picker.endDate | date }}
            <div class="clear-date">
              <v-icon aria-hidden="false" @click="clearDates()">
                mdi-close
              </v-icon>
            </div>
          </template>
        </date-range-picker>

        <v-checkbox
            v-model="notification.only_new_clients"
            label="Только новые клиенты (нет неотменённых заказов)"
            @change="onFilterChange"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" sm="5" md="4" xl="3">
        <div class="mb-4">
          <div>Дата отправки</div>
          <date-picker
              v-model="notification.send_date"
              type="datetime"
              :time-picker-options="timePickerOptions"
              format="YYYY-MM-DD HH:mm"
              placeholder="Select Date & Time"
          />
        </div>
        <v-text-field
            v-model="notification.title"
            label="Заголовок"
            :rules="[rules.required]"
            outlined
        ></v-text-field>
        <v-textarea
            v-model="notification.text"
            label="Описание"
            :rules="[rules.required]"
            outlined
        ></v-textarea>

        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang" class="pt-5">
          <v-tab-item>
            <v-text-field
                v-model="notification.btn_text"
                label="Текст кнопки"
                :rules="[rules.required]"
                outlined
            ></v-text-field>
          </v-tab-item>
          <v-tab-item>

            <v-text-field
                v-model="notification.btn_text_ua"
                label="Текст кнопки"
                :rules="[rules.required]"
                outlined
            ></v-text-field>
          </v-tab-item>
        </v-tabs-items>

        <v-select
            :items="btnTypes"
            v-model="notification.btn_type"
            label="Тип кнопки"
            :rules="[rules.required]"
            outlined
            :item-text="type => type.text"
            :item-value="type => type.id"
        ></v-select>
        <v-text-field
            v-if="notification.btn_type === 'link'"
            v-model="notification.btn_url"
            label="Ссылка"
            outlined
        ></v-text-field>
        <v-text-field
            v-if="notification.btn_type === 'profile-promocodes'"
            v-model="notification.promocode"
            label="Промокод"
            outlined
        ></v-text-field>
        <v-autocomplete
            v-if="notification.btn_type === 'product'"
            v-model="notification.product"
            :items="products"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="id"
            label="Блюдо"
            outlined
            :rules="[rules.required]"
            required
            return-object
        ></v-autocomplete>
        <v-select
            v-if="notification.btn_type === 'category'"
            :items="categories"
            :item-text="category => category.name"
            :item-value="category => category.id"
            v-model="notification.category"
            label="Категория"
            outlined
            :rules="[rules.required]"
            required
            return-object
        ></v-select>
        <div class="notification-page-btn">
        <v-btn @click="update">Отправить</v-btn>
        <span class="addr-info">всего: {{addrCount.tokens + addrCount.tokensDisabled}}</span>
        <span class="addr-info">приложение: {{addrCount.tokens}}</span>
        <span class="addr-info">уведомление: {{addrCount.tokensDisabled}}</span>
        </div>
      </v-col>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PageService from './../../api/PageService'
import NotificationService from "@/api/NotificationService";
import ProductService from "@/api/ProductService";
import CategoryService from "@/api/CategoryService";
import DateRangePicker from 'vue2-daterange-picker'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Vue from 'vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';  // Required for styles

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {BtnTypesHelper} from "../../helpers/btn-types.helper";

export default {
  name: 'PushNotification',
  props: {},
  components: {
    DateRangePicker,
    Multiselect,
    DatePicker,
  },
  filters: {
    date: function (value) {
      if (!value) return ''

      return moment(value).format('YYYY-MM-DD');
    }
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    search: '',
    isLoading: false,
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    btnTypes: BtnTypesHelper.TYPES,
    appTypes: [
      {
        id: 'ios',
        text: 'IOS'
      },
      {
        id: 'android',
        text: 'Android'
      },
    ],
    appVersions: [],
    appVersionsFiltered: [],
    userPhones: [],
    valid: true,
    loadingSelector: false,
    tab: '',
    tabLang: '',
    headerImage: null,
    listOfContact: null,
    categories: [],
    products: [],
    addrCount: {
      tokens: 0,
      tokensDisabled: 0,
    },
    timePickerOptions: {
      start: '00:00',
      step: '00:30',  // 30-min increments
      end: '23:30'
    },
    notification: {
      title: '',
      text: '',
      link: '',
      btn_url: '',
      promocode: '',
      product: null,
      category: null,
      btn_type: null,
      app_type: [],
      version: [],
      number: [],
      send_date: new Date(),
      date_range: {
        startDate: new Date('2000-01-01'),
        endDate: new Date(+(new Date()) + 24*60*60*1000),
      },
      btn_text: '',
      btn_text_ua: '',
      only_new_clients: false,
    },
    loading: false,
    loadingButton: false,
  }),
  mounted() {
    let params = {
      show_disabled: true
    }

    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);

      const promo = urlParams.get('promocode');
      if (promo) {
        this.notification.btn_type = 'profile-promocodes';
        this.notification.btn_text = 'применить';
        this.notification.btn_text_ua = 'застосувати';
        this.notification.promocode = promo;
      }
    }

    CategoryService.list(params).then(response => {
      this.categories = response.data
    });

    NotificationService.getFormDetails().then(response => {

      this.appVersionsFiltered = this.appVersions = [ ...response.data.versions.map(item => ({
        text: item.app_version,
        id: item.app_version,
      }))];

      this.userPhones = [];
    });



    NotificationService.sendPreview(this.getData()).then(response => {
      this.addrCount = response.data;
    }).catch(console.error);
  },
  watch: {
    search (val) {
      if (this.isLoading) return
      this.isLoading = true

      ProductService.findByName({word: this.search}).then(response => {
        this.products = response.data;
      }).finally(response => {
        this.isLoading = false
      });
    }
  },
  methods: {
    clearDates() {
      this.notification.date_range = {
        startDate: new Date('2000-01-01'),
        endDate: new Date(+(new Date()) + 24*60*60*1000),
      };
      this.onFilterChange();
    },
    onDateChange() {
      this.onFilterChange();
    },
    onFilterChange(){
      const tm = setTimeout(() => {

        let formData = this.getData();

        NotificationService.sendPreview(formData).then(response => {
          this.addrCount = response.data;
        }).catch(console.error);

        clearTimeout(tm);

      }, 200);
    },
    onContactFilterChange(){
      const tm = setTimeout(() => {

        let formData = this.getData();

        NotificationService.sendPreview(formData).then(response => {
          this.addrCount = response.data;
        }).catch(console.error);

        clearTimeout(tm);

      }, 200);
    },
    async phoneInputChange(query) {
        this.loading = true;

        const res = await Vue.axios.get('/notifications-search-users?pattern=' + query)
        this.userPhones = res.data.users.map((item) => {
          return {id: item.id, text: item.name + ' ( ' + item.phone + ' )' };
        });

        this.loading = false;
    },
    appVersionChange() {
      this.notification.number = [];
      this.onFilterChange();
    },
    appPhoneChange() {
      this.notification.app_type = [];
      this.notification.version = [];
      this.onFilterChange();
    },
    appChange() {
      this.notification.number = [];
      if (this.notification.app_type.length === 1) {
        const isIOS = this.notification.app_type[0].id === 'ios';

        const exp = isIOS ? /ios/i : /and/i;

        this.appVersionsFiltered = this.appVersions.filter((item) => {
            return exp.test(item.text);
        });

        this.notification.version = this.notification.version.filter((item) => {
          return exp.test(item.text);
        });
      } else {
        this.appVersionsFiltered = this.appVersions;
      }
      this.onFilterChange();
    },
    validate() {
      this.$refs.pushNotificationForm.validate()
    },
    previewImage(isHeader, image) {
      if (isHeader) {
        if (this.headerImage && this.headerImage.url) {
          return this.headerImage.url
        }
      } else {
        if (this.footerImage && this.footerImage.url) {
          return this.footerImage.url
        }
      }

      if (image) {
        return URL.createObjectURL(image)
      }
    },
    update() {
      this.validate()
      if(!this.valid){
        return false
      }
      this.loadingButton = true;
      let formData = this.getData();

      NotificationService.send(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Рассылка отправлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при отправки рассылки отправлена';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },

    prepareUserPhones() {
      return this.notification.number.map(item => item.id).join(',');
    },
    prepareAppType() {
      return this.notification.app_type.map(item => item.id).join(',');
    },
    prepareVersions() {
      return this.notification.version.map(item => item.id).join(',');
    },
    getData() {
      let formData = new FormData();

      formData.append('title', this.notification.title);
      formData.append('text', this.notification.text);
      formData.append('send_date', +this.notification.send_date);
      formData.append('data[btn_url]', this.notification.btn_url);
      formData.append('data[promocode]', this.notification.promocode);
      formData.append('data[btn_text]', this.notification.btn_text);
      formData.append('data[btn_text_ua]', this.notification.btn_text_ua);
      formData.append('data[btn_type]', this.notification.btn_type);
      formData.append('filter[date_range_start]', moment(this.notification.date_range.startDate).format('YYYY-MM-DD'));
      formData.append('filter[date_range_finish]', moment(this.notification.date_range.endDate).format('YYYY-MM-DD'));
      formData.append('filter[version]', this.prepareVersions());
      formData.append('filter[number]', this.prepareUserPhones());
      formData.append('filter[app_type]', this.prepareAppType());
      formData.append('filter[only_new_clients]', this.notification.only_new_clients ? 1 : 0);

      if (this.notification.btn_type === 'product' && this.notification.product) {
        formData.append('data[product]', this.notification.product.id);
      }

      if (this.notification.btn_type === 'category' && this.notification.category) {
        formData.append('data[category]', this.notification.category.id);
      }

      if (this.headerImage && !this.headerImage.url) {
        formData.append('image', this.headerImage);
      }

      if (this.listOfContact && !this.listOfContact.url) {
        formData.append('contact_list', this.listOfContact);
      }

      return formData;
    }
  },
}
</script>

<style lang="scss">
.paymentDelivery-page {
  .v-input__append-inner {
    margin-top: 13px !important;
  }
}
</style>

<style scoped lang="scss">
.paymentDelivery-images .v-image {
  max-height: 374px;
}

.vue-daterange-picker {
  margin-top: 120px;
}

.mobile {
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}

.paymentDelivery {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: solid;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}

.clear-date button {
  position: absolute;
  right: 0;
  top: 5px;
  color: red;
}


.notification-page-btn {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  button {
    width: 105px;
  }

  span {
    font-style: italic;
    font-size: 11px;
    width: 105px;
    background-color: #f4f4f4;
    padding-right: 5px;
    padding-left: 5px;
  }
}

</style>
